// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Y8-z","fadeIn":"Z8-z","delay":"_8-z","recommendedSizeTooltip":"a9-z"};